(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], function(){ return factory(root); });
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(globalThis || (typeof self !== 'undefined' ? self : this));
  } else {
    root.SwishVolleyballLines = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (GLOBAL) {
  'use strict';

  function normHex(x){ if(!x) return '#FFFFFF'; x=String(x).trim(); if(x[0] !== '#') x='#'+x; return x.toUpperCase(); }
  function hasKeys(obj) {
    if (!obj) return false;
    for (const _ in obj) return true;
    return false;
  }
  function resolveOfficial(rulesetId) {
    const cfg = GLOBAL && GLOBAL.SwishCBConfig;
    if (cfg && typeof cfg.resolveOfficialCourtGeometry === 'function') {
      try { return cfg.resolveOfficialCourtGeometry(rulesetId, { noSeries: true }); } catch (_) {}
    }
    return null;
  }

  const OFFICIAL = resolveOfficial('VOLLEYBALL');
  const OFFICIAL_RAW = (OFFICIAL && OFFICIAL.official) || {};
  const OFFICIAL_FEATURE = OFFICIAL && OFFICIAL.features && OFFICIAL.features.volleyball;
  const COURT = {
    LENGTH: Number(OFFICIAL && OFFICIAL.officialLengthM) || 18,
    WIDTH: Number(OFFICIAL && OFFICIAL.officialWidthM) || 9,
    FRONT_ZONE: Number(OFFICIAL_RAW.attackLineFromCenter) || 3,
    LINE: Number(OFFICIAL && OFFICIAL.lineWidthM) || 0.05,
    ATTACK_EXTENSION_DASH: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.attackExtensionDashLengthM) || 0.15,
    ATTACK_EXTENSION_GAP: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.attackExtensionGapM) || 0.20,
    ATTACK_EXTENSION_COUNT: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.attackExtensionCount) || 5,
    SERVICE_ZONE_MARK_LENGTH: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.serviceZoneMarkLengthM) || 0.15,
    SERVICE_ZONE_MARK_GAP: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.serviceZoneMarkGapFromEndlineM) || 0.20
  };
  const HALF_LENGTH = COURT.LENGTH / 2; // 9
  const BACK_ZONE_DEPTH = HALF_LENGTH - COURT.FRONT_ZONE; // 6
  const LEFT_BACK_END = BACK_ZONE_DEPTH;
  const LEFT_FRONT_END = HALF_LENGTH;
  const RIGHT_FRONT_START = HALF_LENGTH;
  const RIGHT_FRONT_END = HALF_LENGTH + COURT.FRONT_ZONE;
  const RIGHT_BACK_START = RIGHT_FRONT_END;
  const SKIP_COLOR = '__SKIP__';

  function makePart(id, order, role, fallback, side, draw) {
    return { id, order, role, fallback, side, draw };
  }

  function fillRect(ctx, dims, color, x, y, w, h) {
    ctx.fillStyle = (GLOBAL.SwishCBHardwood && typeof GLOBAL.SwishCBHardwood.getFillStyle === 'function')
      ? GLOBAL.SwishCBHardwood.getFillStyle(ctx, color, { hardwood: dims.hardwood, pattern: dims.pattern, patternTarget: dims.patternTarget, pixelsPerMeter: dims.scaleAvg })
      : color;
    ctx.fillRect(
      x * dims.scaleX,
      y * dims.scaleY,
      w * dims.scaleX,
      h * dims.scaleY
    );
  }

  // Use filled rects instead of strokes to keep line thickness visually uniform.
  function fillLineH(ctx, dims, color, x1, x2, yM, widthM, align) {
    const wPx = dims.fixedLineWidthPx || (widthM * dims.scaleAvg);
    const xPx1 = x1 * dims.scaleX;
    const xPx2 = x2 * dims.scaleX;
    const left = Math.min(xPx1, xPx2);
    const width = Math.abs(xPx2 - xPx1);
    const yPx = yM * dims.scaleY;
    const top =
      align === 'inside-top' ? yPx :
      align === 'inside-bottom' ? (yPx - wPx) :
      (yPx - wPx / 2);
    ctx.fillStyle = color;
    ctx.fillRect(left, top, width, wPx);
  }

  function fillLineV(ctx, dims, color, xM, y1, y2, widthM, align) {
    const wPx = dims.fixedLineWidthPx || (widthM * dims.scaleAvg);
    const yPx1 = y1 * dims.scaleY;
    const yPx2 = y2 * dims.scaleY;
    const top = Math.min(yPx1, yPx2);
    const height = Math.abs(yPx2 - yPx1);
    const xPx = xM * dims.scaleX;
    const left =
      align === 'inside-left' ? xPx :
      align === 'inside-right' ? (xPx - wPx) :
      (xPx - wPx / 2);
    ctx.fillStyle = color;
    ctx.fillRect(left, top, wPx, height);
  }

  function fillAttackLineExtension(ctx, dims, color, xM, edge, align) {
    const dash = COURT.ATTACK_EXTENSION_DASH;
    const gap = COURT.ATTACK_EXTENSION_GAP;
    const count = COURT.ATTACK_EXTENSION_COUNT;
    for (let i = 0; i < count; i += 1) {
      if (edge === 'top') {
        const y2 = -(gap + (i * (dash + gap)));
        const y1 = y2 - dash;
        fillLineV(ctx, dims, color, xM, y1, y2, COURT.LINE, align);
      } else {
        const y1 = COURT.WIDTH + gap + (i * (dash + gap));
        const y2 = y1 + dash;
        fillLineV(ctx, dims, color, xM, y1, y2, COURT.LINE, align);
      }
    }
  }

  function fillServiceZoneMark(ctx, dims, color, end, edge) {
    const gap = COURT.SERVICE_ZONE_MARK_GAP;
    const len = COURT.SERVICE_ZONE_MARK_LENGTH;
    const x1 = end === 'left' ? -gap - len : COURT.LENGTH + gap;
    const x2 = end === 'left' ? -gap : COURT.LENGTH + gap + len;
    const y = edge === 'top' ? 0 : COURT.WIDTH;
    fillLineH(ctx, dims, color, x1, x2, y, COURT.LINE, 'center');
  }

  const PARTS = [
    makePart('volleyballLeftBackZone', 10, 'area', 'main', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, 0, 0, LEFT_BACK_END, COURT.WIDTH);
    }),
    makePart('volleyballLeftFrontZone', 20, 'area', 'key', 'left', (ctx, dims, color) => {
      fillRect(ctx, dims, color, LEFT_BACK_END, 0, COURT.FRONT_ZONE, COURT.WIDTH);
    }),
    makePart('volleyballRightFrontZone', 30, 'area', 'key', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, RIGHT_FRONT_START, 0, COURT.FRONT_ZONE, COURT.WIDTH);
    }),
    makePart('volleyballRightBackZone', 40, 'area', 'main', 'right', (ctx, dims, color) => {
      fillRect(ctx, dims, color, RIGHT_BACK_START, 0, COURT.LENGTH - RIGHT_BACK_START, COURT.WIDTH);
    }),
    makePart('volleyballSidelineTop', 200, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, 0, COURT.LENGTH, 0, COURT.LINE, 'inside-top');
    }),
    makePart('volleyballSidelineBottom', 210, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineH(ctx, dims, color, 0, COURT.LENGTH, COURT.WIDTH, COURT.LINE, 'inside-bottom');
    }),
    makePart('volleyballBaselineLeft', 220, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, 0, 0, COURT.WIDTH, COURT.LINE, 'inside-left');
    }),
    makePart('volleyballBaselineRight', 230, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, COURT.LENGTH, 0, COURT.WIDTH, COURT.LINE, 'inside-right');
    }),
    makePart('volleyballCenterLine', 240, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, HALF_LENGTH, 0, COURT.WIDTH, COURT.LINE, 'center');
    }),
    makePart('volleyballLeftAttackLine', 250, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, LEFT_BACK_END, 0, COURT.WIDTH, COURT.LINE, 'inside-left');
    }),
    makePart('volleyballRightAttackLine', 260, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillLineV(ctx, dims, color, RIGHT_FRONT_END, 0, COURT.WIDTH, COURT.LINE, 'inside-right');
    }),
    makePart('volleyballLeftAttackExtensionTop', 270, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillAttackLineExtension(ctx, dims, color, LEFT_BACK_END, 'top', 'inside-left');
    }),
    makePart('volleyballLeftAttackExtensionBottom', 280, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillAttackLineExtension(ctx, dims, color, LEFT_BACK_END, 'bottom', 'inside-left');
    }),
    makePart('volleyballRightAttackExtensionTop', 290, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillAttackLineExtension(ctx, dims, color, RIGHT_FRONT_END, 'top', 'inside-right');
    }),
    makePart('volleyballRightAttackExtensionBottom', 300, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillAttackLineExtension(ctx, dims, color, RIGHT_FRONT_END, 'bottom', 'inside-right');
    }),
    makePart('volleyballLeftServiceZoneTop', 310, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillServiceZoneMark(ctx, dims, color, 'left', 'top');
    }),
    makePart('volleyballLeftServiceZoneBottom', 320, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillServiceZoneMark(ctx, dims, color, 'left', 'bottom');
    }),
    makePart('volleyballRightServiceZoneTop', 330, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillServiceZoneMark(ctx, dims, color, 'right', 'top');
    }),
    makePart('volleyballRightServiceZoneBottom', 340, 'line', 'lines', 'center', (ctx, dims, color) => {
      fillServiceZoneMark(ctx, dims, color, 'right', 'bottom');
    })
  ];

  const PART_LOOKUP = PARTS.reduce((acc, part) => {
    acc[part.id] = part;
    return acc;
  }, Object.create(null));
  const DRAW_ORDER = PARTS.slice().sort((a, b) => a.order - b.order).map(part => part.id);
  const LINE_ONLY_ORDER = DRAW_ORDER.filter(id => PART_LOOKUP[id] && PART_LOOKUP[id].role === 'line');

  function computeDims(cw, ch, opts) {
    const scaleX = cw / COURT.LENGTH;
    const scaleY = ch / COURT.WIDTH;
    return {
      scaleX,
      scaleY,
      scaleAvg: (scaleX + scaleY) * 0.5,
      fixedLineWidthPx: Math.max(0, Number(opts && opts.fixedLineWidthPx) || 0),
      cw,
      ch
    };
  }

  function pickDetailColor(detailColors, fallbackColors, id, fallback, baseColor) {
    if (detailColors && detailColors[id]) {
      if (detailColors[id] === SKIP_COLOR) return null;
      return detailColors[id];
    }
    if (fallbackColors && fallbackColors[id]) {
      if (fallbackColors[id] === SKIP_COLOR) return null;
      return fallbackColors[id];
    }
    if (fallback === 'key') return baseColor.key || baseColor.main;
    if (fallback === 'border') return baseColor.border || baseColor.main;
    if (fallback === 'lines') return baseColor.lines;
    return baseColor.main;
  }

  const DEFAULT_PALETTE = {
    main: '#0B3D91',
    key: '#F45D01',
    border: '#001B44',
    lines: '#FFFFFF'
  };

  function draw(ctx, x0, y0, cw, ch, color, opts) {
    if (!ctx || !cw || !ch) return;
    const detailColors = (opts && opts.detailColors) || null;
    const fallbackColors = (opts && opts.fallbackColors) || null;
    const only = (opts && (opts.only === 'left' || opts.only === 'right')) ? opts.only : null;
    const useDetailedParts = !!(opts && opts.useDetailedParts);
    const hasCustom = hasKeys(detailColors) || hasKeys(fallbackColors);
    const drawDetailed = useDetailedParts || hasCustom;
    const order = drawDetailed ? DRAW_ORDER : LINE_ONLY_ORDER;

    ctx.save();
    ctx.translate(x0, y0);
    const dims = computeDims(cw, ch, opts);
    dims.hardwood = opts && opts.hardwood;
    dims.pattern = opts && opts.pattern;
    dims.patternTargetPrefix = opts && opts.patternTargetPrefix;
    const palette = {
      main: DEFAULT_PALETTE.main,
      key: DEFAULT_PALETTE.key,
      border: DEFAULT_PALETTE.border,
      lines: normHex(color || DEFAULT_PALETTE.lines)
    };

    for (const id of order) {
      const part = PART_LOOKUP[id];
      if (!part) continue;
      if (only && part.side && part.side !== only && part.side !== 'center') continue;
      const fill = pickDetailColor(detailColors, fallbackColors, id, part.fallback, palette);
      if (!fill) continue;
      try {
        dims.patternTarget = { id: (dims.patternTargetPrefix || '') + id, role: part.role, fallback: part.fallback };
        part.draw(ctx, dims, normHex(fill));
      } catch (err) {
        console.warn('[SwishVolleyballLines] draw error for part', id, err);
      }
    }

    ctx.restore();
  }

  const api = {
    design: { W: COURT.WIDTH * 1000, L: COURT.LENGTH * 1000 },
    draw,
    ready: Promise.resolve()
  };

  return api;
}));
